export default {
	backgroundPermissionRationale_message:
		'Damit {applicationName} das Geofencing auch im Hintergrund durchführen kann erteilen Sie bitte die Berechtigung {backgroundPermissionOptionLabel}',
	backgroundPermissionRationale_negativeAction: 'Abbrechen',
	backgroundPermissionRationale_positiveAction: 'Ändern in {backgroundPermissionOptionLabel}',
	backgroundPermissionRationale_title:
		'Erlauben Sie {applicationName} den Standort des Geräts im Hintergrund abzufragen?',
	location_accept: 'Akzeptieren',
	location_app_disclosure: `In der infra-struktur App kann der Benutzer ein Geofence-Feature zur Nutzung des Präsenzmanagement aktivieren.
Notwendige Berechtigungen sind:
- Standort
- Körperliche Aktivität

Es werden keine Daten zu "Körperliche Aktivität" auf dem Device oder am Server gespeichert.
Diese werden nur verwendet um die Bestimmung des Geofence nur bei einer Bewegung des Device zu erheben.
Es werden keine Geokoordinaten in der App oder am Server gespeichert.
Die App überträgt nur bei betreten oder verlassen des als Geofence definierten Standorts die Information 0 oder 1 an den Server.
Wird der als Geofence definierte Standort administrativ geändert wird die Geofence Funktion automatisch deaktiviert und muss vom Benutzer wieder aktiviert werden.`,
	location_deny: 'Ablehnen',
	locationAuthorizationAlert_cancelButton: 'Abbrechen',
	locationAuthorizationAlert_instructions:
		'Damit infra-struktur das Geofencing auch im Hintergrund durchführen kann erteilen Sie bitte die Standort Berechtigung "Immer"',
	locationAuthorizationAlert_settingsButton: 'Einstellungen',
	locationAuthorizationAlert_titleWhenNotEnabled: 'Die Standort Dienste sind nicht aktiviert',
	locationAuthorizationAlert_titleWhenOff: 'Die Standort Dienste sind nicht eingeschaltet',
	notification_text: 'Das Geofencing ist aktiv',
	notification_title: 'infra-struktur Geofencing',
};
